import EditRecipeTemplate from './EditRecipeTemplate';
export default EditRecipeTemplate;
